import React, { useState } from "react";
import "./Login.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faUser } from "@fortawesome/free-solid-svg-icons";
import { Controller, useForm } from "react-hook-form";
import { Button, Form } from "react-bootstrap";
import Yellow_Btn from "../../common/common_btn/yellow_btn/Yellow_Btn";
import { useNavigate } from "react-router-dom";

import Yellow_Outline_Btn from "../../common/common_btn/yellow_outline_btn/Yellow_Outline_Btn";
import Success_Lottie from "../../assets/animation/success_lottie/Success_Lottie";

const Login = () => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      rememberMe: true,
    },
  });

  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);

  const onSubmit = (data) => {
    setSuccess(true);
  };

  return (
    <section className="Login">
      <div className="container-fluid p-0">
        <div className="login-card">
          {!success ? (
            <div className="inner_div">
              <h2 className="title">Welcome Back!</h2>
              <p className="subtitle">Enter your Login details below</p>

              <Form onSubmit={handleSubmit(onSubmit)}>
                {/* Username Input */}
                <div className="form-group mb-3">
                  <div className="input-container">
                    <span className="icon-wrapper user-icon">
                      <FontAwesomeIcon icon={faUser} />
                    </span>
                    <Controller
                      name="username"
                      control={control}
                      rules={{ required: "Username is required" }}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="text"
                          placeholder="Enter Username"
                          isInvalid={!!errors.username}
                          className="custom-bootstrap-input"
                        />
                      )}
                    />
                  </div>
                  {errors?.username && (
                    <span className="error-text">
                      {errors.username.message}
                    </span>
                  )}
                </div>

                {/* Password Input */}
                <div className="form-group mb-3">
                  <div className="input-container">
                    <span className="icon-wrapper lock-icon">
                      <FontAwesomeIcon icon={faLock} />
                    </span>
                    <Controller
                      name="password"
                      control={control}
                      rules={{ required: "Password is required" }}
                      render={({ field }) => (
                        <Form.Control
                          {...field}
                          type="password"
                          placeholder="Enter Password"
                          isInvalid={!!errors.password}
                          className="custom-bootstrap-input"
                        />
                      )}
                    />
                  </div>
                  {errors?.password && (
                    <span className="error-text">
                      {errors.password.message}
                    </span>
                  )}
                </div>

                {/* Remember Me Checkbox */}
                <div className="remember-section">
                  <Controller
                    name="rememberMe"
                    control={control}
                    render={({ field: { value, onChange, ref, ...field } }) => (
                      <Form.Check
                        {...field}
                        type="checkbox"
                        id="rememberMe"
                        label="Remember me"
                        checked={value}
                        onChange={(e) => onChange(e.target.checked)}
                        className="custom-bootstrap-checkbox"
                      />
                    )}
                  />
                  <p className="subtext">Keep me signed in on this device.</p>
                </div>

                {/* Submit Button */}
                <Yellow_Btn btnText="Login Now" type="submit" />
              </Form>
            </div>
          ) : (
            <div className="success_div inner_div">
              <h2 className="title">Welcome Back!</h2>
              <p className="subtitle">You have successfully logged in.</p>
              <div className="success_lottie_div">
                <Success_Lottie />
              </div>
              <Yellow_Outline_Btn
                btnText="Explore Now"
                onClick={() => navigate("/dashboard")}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Login;
